module.exports = __webpack_public_path__ + "media/images/icon__profile@3x-7b8ae7b941606d915a1c112569cb30d6.png";